<template>
  <el-table-column
    :prop="columnConfig.prop"
    :label="columnConfig.label"
    :width="columnConfig.width"
    :align="columnConfig.align"
    :min-width="columnConfig.minWidth"
  >
    <template
      v-if="columnConfig.template || filters"
      v-slot="scope"
    >
      <component
        :is="columnConfig.template"
        :row="scope.row"
        v-bind="columnConfig.getBind(thisComponent, scope)"
        v-on="columnConfig.getVon(thisComponent, scope)"
        @remove-card="$emit('remove-card', $event)"
        @element-changed="$emit('element-changed', $event)"
        @element-deleted="$emit('element-deleted', $event)"
      ></component>

      <div v-if="filters">
        {{format($companyConfiguration.helpers.getObjectPropByString(scope.row, filters[0]), filters[1])}}
      </div>
    </template>
  </el-table-column>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import Vue from "vue";

export default {
  name: 'base-matrix-table-column',
  components: {ClickToEdit},

  props: {
    columnConfig: {type: Object, required: true},
  },
  data() {
    return {
      thisComponent: this,
    }
  },
  computed: {
    filters(){
      if( !this.columnConfig.prop ){
        return null;
      }
      let filter = this.columnConfig.prop.split('|');
      return filter[1] ? filter : null;
    }
  },
  methods: {
    format(value, filter){
      return Vue.filter(filter)(value);
    }
  }
}

</script>

<style>

</style>
